import { createContext } from "react";

export const AppContext = createContext({});
export const ServiceContext = createContext({});
export const ViewerContext = createContext({});
export const AdminContext = createContext({});
